export const brandModels: Record<string, string[]> = {
  'DAF': ['XD', 'XF', 'XG'],
  'Ford': ['Cargo', 'F-MAX'],
  'Iveco': ['Daily', 'Eurocargo', 'S-Way', 'T-Way'],
  'MAN': ['TGM-Series', 'TGS-Series', 'TGX-Series'],
  'Mercedes-Benz': ['Actros', 'Arocs', 'Atego'],
  'Mitsubishi Fuso': ['Canter'],
  'Renault': ['C-Series', 'D-Series', 'T-Series'],
  'Scania': ['G-Series', 'P-Series', 'R-Series', 'S-Series'],
  'Volvo': ['FH-Series', 'FM-Series']
};

export const brands = Object.keys(brandModels);
